/**
 * 购物车抽屉关闭 / 摘要折叠 / /cart 吸底。
 *
 * 关抽屉要点两下，是主题 Dialog + FocusTrap 的交互：
 * 1. FocusTrap.allowOutsideClick 用 contains() 看不到 Shadow overlay；
 *    触摸路径固定 return false，第一次 tap 被吞掉。
 * 2. BFCache pageshow 会整段刷新抽屉 DOM，旧 trap 还活着。
 */
(function () {
  function pathOf(event) {
    try {
      if (event.composedPath) return event.composedPath();
    } catch (e) {}
    return event.target ? [event.target] : [];
  }

  var IGNORE_OUTSIDE_HIDE_MS = 650;

  function armCartIgnoreOutside(drawer) {
    if (!drawer) return;
    drawer._awIgnoreHideUntil = Date.now() + IGNORE_OUTSIDE_HIDE_MS;
  }

  function isAddToCartGesture(event) {
    var t = event && event.target;
    if (!t || !t.closest) return false;
    if (t.closest(".anywell-sticky-purchase")) return true;
    if (t.closest('form[is="product-form"], product-form, form[action*="/cart/add"]')) return true;
    return false;
  }

  function patchCartDrawer() {
    var Ctor = window.customElements && window.customElements.get("cart-drawer");
    if (!Ctor || !Ctor.prototype || Ctor.prototype.__awCheckoutPrepFix) return;
    Ctor.prototype.__awCheckoutPrepFix = true;

    var origPageShow = Ctor.prototype._onPageShow;
    var origAllow = Ctor.prototype._allowOutsideClick;
    var origShow = Ctor.prototype.show;

    if (typeof origPageShow === "function") {
      Ctor.prototype._onPageShow = function (event) {
        if (event && event.persisted) return;
        return origPageShow.call(this, event);
      };
    }

    if (typeof origShow === "function") {
      Ctor.prototype.show = function () {
        armCartIgnoreOutside(this);
        return origShow.apply(this, arguments);
      };
    }

    Ctor.prototype._allowOutsideClick = function (event) {
      if (this.id !== "cart-drawer") {
        return origAllow ? origAllow.call(this, event) : true;
      }
      // Add-to-cart opens the drawer async; the same tap must not instantly close it.
      if (Date.now() < (this._awIgnoreHideUntil || 0) || isAddToCartGesture(event)) {
        return false;
      }
      var path = pathOf(event);
      var inside = false;
      for (var i = 0; i < path.length; i += 1) {
        if (path[i] === this) {
          inside = true;
          break;
        }
      }
      if (inside || (event.target && this.contains(event.target))) return true;
      this.hide();
      var control =
        event.target &&
        event.target.closest &&
        event.target.closest('[aria-controls="' + this.id + '"]');
      return !control;
    };
  }

  document.addEventListener("variant:add", function () {
    armCartIgnoreOutside(document.getElementById("cart-drawer"));
  });

  if (window.customElements && window.customElements.get("cart-drawer")) {
    patchCartDrawer();
  } else if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined("cart-drawer").then(patchCartDrawer);
  }

  function isMobile() {
    return window.matchMedia("(max-width: 699px)").matches;
  }

  function enhanceSummaryToggle(toggle) {
    if (!toggle) return;
    toggle.removeAttribute("hidden");
    toggle.removeAttribute("tabindex");
    if (!toggle.hasAttribute("aria-expanded")) toggle.setAttribute("aria-expanded", "false");
  }

  function enhanceAllSummaries() {
    document.querySelectorAll("[data-dcbi-prep-summary-toggle]").forEach(function (toggle) {
      if (isMobile()) enhanceSummaryToggle(toggle);
      else {
        toggle.setAttribute("hidden", "");
        toggle.setAttribute("tabindex", "-1");
      }
    });
  }

  function unpinCartDock(dock) {
    if (!dock) return;
    dock.classList.remove("is-pinned");
    dock.style.removeProperty("height");
    dock.style.removeProperty("--dcbi-prep-dock-offset");
  }

  function syncDetailsLock() {
    var lock =
      isMobile() &&
      !!document.querySelector("[data-dcbi-prep-dock] [data-dcbi-prep-summary].is-open");
    document.documentElement.classList.toggle("dcbi-prep-details-lock", lock);
  }

  function isCartDrawerOpen() {
    var drawer = document.querySelector("cart-drawer");
    return !!(drawer && drawer.hasAttribute("open"));
  }

  function syncCsLauncher() {
    var detailsOpen = !!document.querySelector("[data-dcbi-prep-summary].is-open");
    var hide = isCartDrawerOpen() || document.documentElement.classList.contains("lock") || detailsOpen;
    document.documentElement.classList.toggle("dcbi-hide-cs-launcher", hide);
  }

  function bindCartDrawerCsHide() {
    var drawer = document.querySelector("#cart-drawer, cart-drawer");
    if (!drawer || drawer.__dcbiCsHideBound) return;
    drawer.__dcbiCsHideBound = true;
    new MutationObserver(syncCsLauncher).observe(drawer, {
      attributes: true,
      attributeFilter: ["open"]
    });
    drawer.addEventListener("dialog:after-show", syncCsLauncher);
    drawer.addEventListener("dialog:after-hide", syncCsLauncher);
    drawer.addEventListener("toggle", syncCsLauncher);
  }

  function syncCartDock() {
    var dock = document.querySelector("[data-dcbi-prep-dock]");
    var root = document.documentElement;
    if (!dock) {
      root.classList.remove("dcbi-has-cart-dock");
      return;
    }
    var form = dock.querySelector(".cart-form");
    if (!form || !isMobile()) {
      root.classList.remove("dcbi-has-cart-dock");
      unpinCartDock(dock);
      return;
    }
    root.classList.add("dcbi-has-cart-dock");
    var height = Math.ceil(form.getBoundingClientRect().height);
    var rect = dock.getBoundingClientRect();
    var detailsOpen = !!dock.querySelector("[data-dcbi-prep-summary].is-open");
    if (detailsOpen || rect.top > window.innerHeight - height) {
      dock.style.setProperty("--dcbi-prep-dock-offset", height + "px");
      dock.classList.add("is-pinned");
    } else {
      unpinCartDock(dock);
    }
  }

  enhanceAllSummaries();
  bindCartDrawerCsHide();
  syncCartDock();
  syncDetailsLock();
  syncCsLauncher();
  document.addEventListener("click", function (event) {
    if (!isMobile()) return;
    var toggle = event.target.closest && event.target.closest("[data-dcbi-prep-summary-toggle]");
    if (!toggle) return;
    var summary = toggle.closest("[data-dcbi-prep-summary]");
    if (!summary) return;
    var open = summary.classList.toggle("is-open");
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    var label = toggle.querySelector("span:not(.dcbi-prep-summary__chevron)");
    if (label) label.textContent = open ? "Hide details" : "View details";
    syncDetailsLock();
    window.requestAnimationFrame(function () {
      syncCartDock();
      syncDetailsLock();
      syncCsLauncher();
    });
  });
  document.addEventListener(
    "touchmove",
    function (event) {
      if (!document.documentElement.classList.contains("dcbi-prep-details-lock")) return;
      var allow = event.target.closest && event.target.closest(".cart-form, cart-drawer");
      if (!allow) event.preventDefault();
    },
    { passive: false }
  );
  window.addEventListener("scroll", syncCartDock, { passive: true });
  window.addEventListener("resize", function () {
    enhanceAllSummaries();
    bindCartDrawerCsHide();
    syncCartDock();
    syncDetailsLock();
    syncCsLauncher();
  });
  if (window.MutationObserver) {
    new MutationObserver(function () {
      enhanceAllSummaries();
      bindCartDrawerCsHide();
      syncCartDock();
      syncDetailsLock();
      syncCsLauncher();
    }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
